export default __webpack_public_path__ + "static/media/HTML_JS_CSS.be2e55a9.webp";